<div
  *ngIf="riskCalulationResult !== undefined"
  fxLayoutAlign="space-between"
  class="div-background-blue"
  style="padding: 0px 20px; padding-right: 10px;"
  fxLayout="row"
>
  <span fxLayoutAlign="start center">
    <span class="facility-type regular">{{
      riskCalulationResult?.facilityType | facilityType
    }}</span>
  </span>
  <span fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="7px">
    <span class="covid-19-risk regular">
      {{'covid19_risk' | transloco}}
    </span>
    <span [ngClass]="riskStatus">
      <span class="risk-text">{{
        riskCalulationResult?.riskLevel | riskLevel |transloco
      }}</span>
    </span>
  </span>
</div>
